import agents from 'Agent/AgentInformation/ducks/agents';
import hierarchy from 'Agent/AgentInformation/ducks/hierarchy';
import news from 'Agent/AgentInformation/ducks/news';
import rateGenerators from 'Agent/AgentInformation/ducks/rateGenerator';

export default {
  agents,
  hierarchy,
  rateGenerators,
  news,
};
